import React, { useState, useEffect } from 'react';
import logError from 'App/babel/helpers/logError';
import { TableColumn } from '@upsales/components';
import Todo from 'App/resources/Model/Todo';
import Activity from 'App/resources/Model/Activity';
import './TodoListTableRowDescriptionCol.scss';
import Appointment from 'App/resources/Model/Appointment';
import ActivityResource from 'Resources/Activity';
import TicketResource from 'App/resources/Ticket';
import RelatedButtons from 'App/components/Buttons/RelatedButtons';
import BemClass from '@upsales/components/Utils/bemClass';
import Ticket from 'App/resources/Model/Ticket';
import Agreement from 'App/resources/Model/Agreement';
import AgreementResource from 'Resources/Agreement';

interface Props {
	todo: Todo | Activity;
	className?: string;
}
const TodoListTableRowDescriptionCol = ({ todo, className }: Props) => {
	const [parentAppointment, setParentAppointment] = useState<Appointment | null>(null);
	const [parentActivity, setParentActivity] = useState<Activity | null>(null);
	const [ticket, setTicket] = useState<Ticket | null>(null);
	const [agreement, setAgreement] = useState<Agreement | null>(null);

	useEffect(() => {
		const getParentEntities = async () => {
			try {
				if (todo.parentAppointmentId) {
					const res = await Tools.Appointment.customer(Tools.AppService.getCustomerId()).get(
						todo.parentAppointmentId
					);
					setParentAppointment(res.data);
				} else {
					setParentAppointment(null);
				}
				if (todo.parentActivityId) {
					const res = await ActivityResource.get(todo.parentActivityId);
					setParentActivity(res.data);
				} else {
					setParentActivity(null);
				}
				if (todo.ticketId) {
					const res = await TicketResource.get(todo.ticketId);
					setTicket(res.data);
				} else {
					setTicket(null);
				}
				if (todo.agreementId) {
					const res = await AgreementResource.get(todo.agreementId);
					setAgreement(res.data);
				} else {
					setAgreement(null);
				}
			} catch (err: any) {
				if (!(err && err.status && err.status !== 404)) {
					logError(err, 'Failed to fetch parent entities');
				}
			}
		};
		getParentEntities();
	}, [todo.parentAppointmentId, todo.parentActivityId, todo.ticketId, todo.agreementId]);

	const classes = new BemClass('TodoListTableRowDescriptionCol').add(className);
	return (
		<TableColumn className={classes.b()}>
			<RelatedButtons
				projectPlan={todo.projectPlan}
				opportunity={todo.opportunity}
				activity={parentActivity}
				appointment={parentAppointment}
				ticket={ticket}
				agreement={agreement}
				fullSize={true}
			/>
		</TableColumn>
	);
};

export default TodoListTableRowDescriptionCol;
